import script from "./AuthView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthView.vue?vue&type=script&setup=true&lang=ts"

import "./AuthView.vue?vue&type=style&index=0&id=5a60acd6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a60acd6"]])

export default __exports__